import React, { useEffect, useState } from 'react'
import { ModalWrapper } from '../../../../../../components'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { cross } from '../../../../../../assets/icons'
import classes from './AddStops.module.css'
import { StaticAlt } from '../../../../../../shared/utils/constants'
import { useGlobal } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import axios from 'axios'
import { setLoader, setRefreshPage, setStopID } from '../../../../../../redux/globalSlice'
import { toast, ToastContainer } from 'react-toastify'
import { Avatar, Typography } from '@mui/material'

const RouteDetail = ({ open, handleClose, setstopDetailsOpen, setHandleOpen }) => {
  // const data = useSelector((state) => state.global.SchoolDInfo)
  const details = useSelector((state) => state.global.choosedRow)
  const [selectedStop, setSelectedStop] = useState(null)
  const { data: stopData } = useGlobal({ userUrl: `${urls.STOP_GET}${details.route_id}` })

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${baseURL}${urls.STOP_DELETE}${selectedStop?.stop_id}`)
      if (response?.data?.status === 202) {
        toast.success('Data Deleted Successfuly')
        dispatch(setLoader(false))
        dispatch(setRefreshPage(true))
      }
    } catch (error) {
      console.error(error)
      toast.error('Error Submitting Data')
    }
  }
  const dispatch = useDispatch()
  return (
    <>
      {/* <ToastContainer /> */}
      <ModalWrapper
        open={open}
        handleClose={handleClose}
        title={`${details.route_name} Details`}
        width={'517px'}
      >
        <div className={classes.container}>
          {/* <InfoField label={'hoy'} value={data?.route_number} width={'100%'} />
        <InfoField label={'Area'} value={data?.route_area} width={'100%'} /> */}
          <div className={classes.subcontainer}>
            <p className={classes.txt}>Route Information</p>
            <div className={classes.details}>
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>Assigned To</p>
                  <p className={classes.detailtxt}>
                  {details?.vans?.length > 0
                    ? details?.vans?.map((van) => van.van_number).join(', ')
                    : 'No van assigned'}
                </p>
              </div>
              <hr className={classes.rule} />
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>Students</p>
                <p className={classes.detailtxt}>{parseInt(details.student_count, 10)}</p>
              </div>
              <hr className={classes.rule} />
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>Stops</p>
                <div className={classes.routetxt}>{parseInt(details.stops_count)}</div>
              </div>
            </div>
          </div>
          <div
            style={{
              gap: '4px',
            }}
            className={classes.subcontainer}
          >
            <div className={classes.top}>
              <div className={classes.titlediv}>
                <p className={classes.txt}>Stops</p>
                <div className={classes.xount}>{stopData?.length}</div>
              </div>
              <p onClick={setHandleOpen} className={classes.addnew}>
                + Add New
              </p>
            </div>
            <div className={classes.stops}>
              {stopData?.map((value, index) => {
                return (
                  <div key={index} className={classes.stop}>
                    <p
                      onClick={() => {
                        setstopDetailsOpen()
                        dispatch(setStopID(value))
                      }}
                      className={classes.stoptxt}
                    >
                      {`${value?.stop_address},` +
                        `${value?.stop_city},` +
                        `${value?.stop_state},` +
                        value?.stop_pincode}
                    </p>
                    <img
                      src={cross}
                      alt={StaticAlt}
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setSelectedStop(value)
                        handleDelete()
                      }}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  )
}

export default RouteDetail

export const VanDriverDetail = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Route Detail'}
      width={'fit-content'}
    >
      <div className="add-employee">
        <div className="emp-det-head">
          <div>
            <Typography className="field-label">Avatar</Typography>
            {data?.employee_avatar ? (
              <img src={data?.employee_avatar} alt="" className="employee-img" />
            ) : (
              <Avatar
                alt={''}
                sx={{
                  width: '76px',
                  height: '76px',
                  mt: 1,
                  fontSize: '30px',
                  backgroundColor: '#F2ECF9',
                  color: '#492972',
                }}
              >
                {data?.employee_name?.charAt(0).toUpperCase()}
              </Avatar>
            )}
          </div>
        </div>
        <div className="text-fields">
          <InfoField label={'Name'} value={data?.employee_name} width={'500px'} />
          {/* <InfoField label={'Last Name'} value={data?.driver_last_name} width={'200px'} /> */}
        </div>
        <InfoField label={'Contact Number'} value={data?.employee_contact_number} width={'100%'} />
        <div className="text-fields">
          <InfoField label={'Gender'} value={data?.employee_gender} width={'200px'} />
          <InfoField
            label={'Date of Joining'}
            value={data?.employee_joining_date.split('T')[0]}
            width={'200px'}
          />
        </div>
        <div className="text-fields">
          <InfoField label={'Address 1'} value={data?.employee_address} width={'200px'} />
          <InfoField label={'Address 2'} value={data?.employee_address_two} width={'200px'} />
        </div>
        <div className="text-fields">
          <InfoField label={'City'} value={data?.employee_city} width={'200px'} />
          <InfoField label={'State'} value={data?.employee_state} width={'200px'} />
        </div>
        <div className="text-fields">
          <InfoField label={'Pincode'} value={data?.employee_pincode} width={'200px'} />
          <InfoField label={'Salary'} value={data?.employee_salary} width={'200px'} />
        </div>
      </div>
    </ModalWrapper>
  )
}

export const StopDetail = ({ addopen, setHandleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  const stopID = useSelector((state) => state.global.StopId)
  const dispatch = useDispatch()
  const [step, setStep] = useState(0)
  const { data: StopList } = useGlobal({
    userUrl: `${urls.STOP_DETAIL}${stopID?.stop_id}`,
  })
  console.log('-----stoplist', StopList)
  const [formData, setFormData] = useState({
    address: '',
    address2: '',
    city: '',
    state: '',
    pincode: '',
  })
  useEffect(() => {
    if (StopList?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        address: StopList[0]?.stop_address || '',
        address2: StopList[0]?.stop_address_two || '',
        city: StopList[0]?.stop_city || '',
        state: StopList[0]?.stop_state || '',
        pincode: StopList[0]?.stop_pincode || '',
      }))
    }
  }, [StopList])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const responseBody = {
      route_id: data?.route_id,
      stop_id: stopID?.stop_id,
      ...formData,
    }
    try {
      const response = await axios.patch(`${baseURL}${urls.STOP_PATCH}`, responseBody)
      if (response?.data?.status == 202 || response?.data?.status == 200) {
        toast.success('Route Updated Successfully!')
        dispatch(setLoader(false))
        setHandleClose()
        dispatch(setRefreshPage(true))
      } else {
        toast.error('Stop is Already Added For Selected Student')
      }
    } catch (error) {
      console.error(error)
      toast.error('Error Submitting Data')
      dispatch(setLoader(false))
    }
    // Close modal after submission
  }
  const handleNext = () => {
    setStep(1)
  }


  

  return (
    <>
      {/* <ToastContainer /> */}
      <ModalWrapper
        open={addopen}
        handleClose={setHandleClose}
        title={`Stop Details`}
        width={'517px'}
      >
        {step === 0 && (
          <div className={classes.container}>
            <div
              style={{
                maxHeight: '196px',
              }}
              className={classes.subcontainer}
            >
              {/* <p className={classes.txt}>Student Information</p>
              <div className={classes.details}>
                {StopList?.length > 0 ? (
                  StopList?.map((student, index) => (
                    <div key={index} className={classes.studentContainer}>
                      <div className={classes.subdetail}>
                        <p className={classes.headingtxt}>Student Name</p>
                        <p className={classes.detailtxt}>{student?.student_name || 'N/A'}</p>
                      </div>
                      <hr className={classes.rule} />
                      <div className={classes.subdetail}>
                        <p className={classes.headingtxt}>Student ID</p>
                        <p className={classes.detailtxt}>
                          {student?.student_registration_number || 'N/A'}
                        </p>
                      </div>
                      {index !== StopList.length - 1 && <hr className={classes.rule} />}
                    </div>
                  ))
                ) : (
                  <p className={classes.noData}>No student data available</p>
                )}
              </div> */}
            </div>
            <div className={classes.subcontainer}>
              <div className={classes.box}>
                <p className={classes.addtxt}>Address</p>
                <p onClick={handleNext} className={classes.edittxt}>
                  View Details
                </p>
              </div>
              <p className={classes.addresstxt}>
                {`${StopList?.[0]?.stop_address},` +
                  `${StopList?.[0]?.stop_city},` +
                  `${StopList?.[0]?.stop_state},` +
                  StopList?.[0]?.stop_pincode}
              </p>
            </div>
          </div>
        )}
        {step === 1 && (
          <form className={classes.form} onSubmit={handleSubmit}>
            <div className={classes.wrapper}>
              <label className={classes.label}>Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className={classes.input}
                placeholder="Enter Address"
              />
            </div>

            <div className={classes.wrapper}>
              <label className={classes.label}>Address 2</label>
              <input
                type="text"
                name="address2"
                value={formData.address2}
                onChange={handleChange}
                className={classes.input}
                placeholder="Enter Address 2"
              />
            </div>

            <div className={classes.wrapper}>
              <label className={classes.label}>City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className={classes.input}
                placeholder="Enter City"
              />
            </div>

            <div className={classes.full}>
              <div className={classes.wrapper}>
                <label className={classes.label}>State</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className={classes.input}
                  placeholder="Enter State"
                />
              </div>
              <div className={classes.wrapper}>
                <label className={classes.label}>Zip Code</label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  className={classes.input}
                  placeholder="Enter Zip Code"
                />
              </div>
            </div>

            <button type="submit" className={classes.button}>
              Update
            </button>
          </form>
        )}
      </ModalWrapper>
    </>
  )
}
